import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';
import InfoModal from "./../../APP/COMPONENTS/InfoModal"

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER,
        TO_ORDER_PRODUCTS: state.TO_ORDER_PRODUCTS
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class CreateRoute extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            PRODUCTS: this.prepareProducts(),
            INFO_MODAL: false,
            DELIVERY_DATE: this.getTomorrowDatePc(),
            DELIVERY_TIME: this.getCurrentDeliveryTime(props.DATA),
        }
    }

    componentDidMount = () => {

    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }

        if (this.props.TO_ORDER_PRODUCTS !== prevProps.TO_ORDER_PRODUCTS) {
            const NEW_PRODUCTS = this.prepareProducts();
            this.setState({ PRODUCTS: NEW_PRODUCTS });
        }
    }

    saveOrderData = async () => {
        if (!this.state.SAVING) {
            this.setState({ SAVING: true })

            let products = [];
            for (let key in this.state.PRODUCTS) {
                let product = this.state.PRODUCTS[key]
                products.push({
                    id: product.id,
                    supplier_amount: product.sup_amount,
                    supplier_price: product.supplier_price
                })
            }

            try {
                let SEND_DATA = {
                    planned_date: this.state.DELIVERY_DATE,
                    planned_time: this.state.DELIVERY_TIME,
                    products: products,
                    comment: ''
                };

                let data = await Request(SEND_DATA, 'incomings/create');
                if (data !== false) {
                    this.props.setProductsToOrder({});
                    this.props.history.push('/orders/' + data)
                    this.setState({ SAVING: false })
                } else {
                    this.setState({ SAVING: false })
                }
            } catch (error) {
                this.setState({ SAVING: false })
            }
        }
    }

    getTodayDatePc = () => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + '-' + mm + '-' + dd;

        return today
    }

    getTomorrowDatePc = () => {
        var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        var dd = String(tomorrow.getDate()).padStart(2, '0');
        var mm = String(tomorrow.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = tomorrow.getFullYear();
        tomorrow = yyyy + '-' + mm + '-' + dd;

        return tomorrow
    }

    getTodayDate = () => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today = dd + '.' + mm + '.' + yyyy;

        return today
    }

    getCurrentDeliveryTime = () => {
        let start = 4;
        let end = 22;

        if (typeof this.props.USER !== "undefined" && typeof this.props.USER.delivery_times !== "undefined" && typeof this.props.USER.delivery_times2 !== "undefined") {
            if (this.props.USER.delivery_times.length && this.props.USER.delivery_times2.length) {
                let start_parts = this.props.USER.delivery_times.split(':');
                start = parseInt(start_parts[0])
                let end_parts = this.props.USER.delivery_times2.split(':');
                end = parseInt(end_parts[0])
            }
        }

        let local_start = start;
        let local_end = start + 1;

        if (local_start < 10) {
            local_start = '0' + local_start
        }
        if (local_end < 10) {
            local_end = '0' + local_end
        }

        let string = local_start + ':00-' + local_end + ':00';

        return string
    }

    prepareProducts = () => {
        let NEW_PRODUCTS = {}
        for (let key in this.props.TO_ORDER_PRODUCTS) {
            NEW_PRODUCTS[key] = this.props.TO_ORDER_PRODUCTS[key]
        }

        return NEW_PRODUCTS
    }

    renderProducts = () => {
        if (this.state.PRODUCTS) {
            let TBODY = this.renderProductsRows();
            let HEADER = this.renderProductsTableHeader();

            return (
                <div className="table_holder">
                    <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                        { HEADER }
                        { TBODY }
                    </table>
                </div>
            );
        } else {
            return <div className="table_holder"><h3>Мы не нашли ваших товаров в базе</h3></div>;
        }
    }

    renderImage = (PRODUCT) => {
        let SRC = PRODUCT.thumb;
        if ((typeof SRC !== "undefined") && (SRC !== "")) {
            return (
                <img
                    className="product_image"
                    src={ SRC }
                />
            );
        }

        return false;
    }

    renderProductStatuses = (PRODUCT) => {
        let STATUSES = [];
        if (parseInt(PRODUCT.archive) == 1) {
            STATUSES.push(
                <span key="archive" className="archive_label">Архив</span>
            );
        }
        if (parseInt(PRODUCT.active) == 0) {
            STATUSES.push(
                <span key="disabled" className="disabled_label">Отключен</span>
            );
        }

        if (STATUSES.length) {
            return (
                <div className="product_title_labels">
                    { STATUSES }
                </div>
            );
        }

        return null;
    }

    addAmountClassToCell = (AMOUNT) => {
        if (parseInt(AMOUNT) == 0) {
            return ' out_of_stock_cell';
        }

        return null;
    }

    fetchModalData = async (product_id, type) => {
        try {
            let SEND_DATA = {
                product_id: product_id,
                type: type
            };

            let data = await Request(SEND_DATA, 'statistics/periodical');
            return data
        } catch (error) {
        }

        return false
    }

    hideModalInfo = () => {
        this.setState({ INFO_MODAL: false })
    }

    showModalInfo = async (PRODUCT, type) => {
        const data = await this.fetchModalData(PRODUCT.id, type)
        if (!data) {
            return
        }

        let title = 'Информация';
        if (type == 'sales') {
            title = 'Продажи'
        } else if (type == 'activity') {
            title = 'Активность'
        } else if (type == 'writeoffs') {
            title = 'Списания'
        }

        this.setState({
            INFO_MODAL: {
                title: title,
                data: data
            }
        })
    }

    renderCheckbox = (PRODUCT) => {
        return (
            <input
                key={ PRODUCT.id + '_checkbox' }
                id={ PRODUCT.id + '_checkbox' }
                type="checkbox"
                onChange={ () => this.props.toggleProductInToOrderProducts(PRODUCT) }
                checked={ typeof this.props.TO_ORDER_PRODUCTS[PRODUCT.id] !== "undefined" }
            />
        )
    }

    changePrice = (price, pid) => {
        let NEW_PRODUCTS = {}
        for (let key in this.props.TO_ORDER_PRODUCTS) {
            NEW_PRODUCTS[key] = this.props.TO_ORDER_PRODUCTS[key]
            if (key == pid) {
                NEW_PRODUCTS[key].supplier_price = price
            }
        }

        this.props.setProductsToOrder(NEW_PRODUCTS);
    }

    changeAmount = (amount, pid) => {
        let NEW_PRODUCTS = {}
        for (let key in this.props.TO_ORDER_PRODUCTS) {
            NEW_PRODUCTS[key] = this.props.TO_ORDER_PRODUCTS[key]
            if (key == pid) {
                NEW_PRODUCTS[key].sup_amount = amount
            }
        }

        this.props.setProductsToOrder(NEW_PRODUCTS);
    }

    changeDays = (days_amount, pid) => {
        let NEW_PRODUCTS = {}
        for (let key in this.props.TO_ORDER_PRODUCTS) {
            NEW_PRODUCTS[key] = this.props.TO_ORDER_PRODUCTS[key]
            if (key == pid) {
                NEW_PRODUCTS[key].days_to_fullfill = days_amount
                NEW_PRODUCTS[key].sup_amount = days_amount * this.props.TO_ORDER_PRODUCTS[key].per_day
            }
        }

        this.props.setProductsToOrder(NEW_PRODUCTS);
    }

    renderProductsRows = (SAVEABLE) => {
        let ROWS = [];
        for (let i in this.state.PRODUCTS) {
            let PRODUCT = this.state.PRODUCTS[i];

                        let amount = 0
            if (!PRODUCT.amounts || !PRODUCT.amounts[1]) {
                amount = 0
            } else {
                amount = PRODUCT.amounts[1].amount
            }

            let reserv = 0
            if (!PRODUCT.reserves || !PRODUCT.reserves[1]) {
                reserv = 0
            } else {
                reserv = PRODUCT.reserves[1].amount
            }

            const totalAmount = amount
            amount -= reserv

            ROWS.push(
                <tr key={ i }>
                    { (typeof SAVEABLE !== "undefined") ? null : (<td className="cell-center">{ this.renderImage(PRODUCT) }</td>) }
                    <td><span className="product_title">{ PRODUCT.name }{ this.renderProductStatuses(PRODUCT) }</span></td>
                    <td className={ "cell-center " + this.addAmountClassToCell(amount) }>{ amount }</td>
                    <td className="cell-center">{ PRODUCT.unit_name }</td>

                    <td className="cell-center">{ PRODUCT.statistics.sales } { PRODUCT.unit_name }</td>
                    <td className="cell-center">{ PRODUCT.statistics.sales_10 } { PRODUCT.unit_name }{ (typeof SAVEABLE !== "undefined") ? null : (<a className="info_link" onClick={ () => this.showModalInfo(PRODUCT, 'sales') }><img src="/system_images/info.png" /></a>) }</td>

                    <td className="cell-center">{ PRODUCT.statistics.writeoff_10 } { PRODUCT.unit_name }{ (typeof SAVEABLE !== "undefined") ? null : (<a className="info_link" onClick={ () => this.showModalInfo(PRODUCT, 'writeoff') }><img src="/system_images/info.png" /></a>) }</td>
                    <td className="cell-center">{ PRODUCT.statistics.activity }{ (typeof SAVEABLE !== "undefined") ? null : (<a className="info_link" onClick={ () => this.showModalInfo(PRODUCT, 'activity') }><img src="/system_images/info.png" /></a>) }</td>
                    <td className="cell-center">
                        <input type="number" min="0" value={ PRODUCT.supplier_price } onChange={ (e) => this.changePrice(e.target.value, PRODUCT.id) } />
                    </td>
                    <td className="cell-center">
                        <input type="number" min="0" value={ PRODUCT.days_to_fullfill } onChange={ (e) => this.changeDays(e.target.value, PRODUCT.id) } />
                    </td>
                    <td className="cell-center">
                        <input type="number" min="0" value={ PRODUCT.sup_amount } onChange={ (e) => this.changeAmount(e.target.value, PRODUCT.id) } />
                    </td>
                    <td className="cell-center">
                        { PRODUCT.sup_amount * PRODUCT.supplier_price } руб
                    </td>

                    { (typeof SAVEABLE !== "undefined" || this.state.USER.selforder == 0) ? null : (<td className="cell-center">{ this.renderCheckbox(PRODUCT) }</td>) }
                </tr>
            );
        }

        return (
            <tbody>
                { ROWS }
            </tbody>
        );
    }

    changeDeliveryTime = (date) => {
        this.setState({ DELIVERY_TIME: date })
    }

    renderProductsTableHeader = (SAVEABLE) => {
        return (
            <thead>
                <tr>
                    { (typeof SAVEABLE !== "undefined") ? null : (<th>фото</th>) }
                    <th>наименование</th>
                    <th>кол-во<br />МСК</th>
                    <th>единица<br />измерения</th>
                    <th>продажи<br />вчера</th>
                    <th>продажи<br />за 10д</th>

                    <th>списания<br />за 10д</th>
                    <th>активность<br />за 30д</th>
                    <th>цена</th>
                    <th>запас на<br />кол-во дней</th>
                    <th>количество</th>
                    <th>сумма</th>
                    { (typeof SAVEABLE !== "undefined" || this.state.USER.supplier.selforder == 0) ? null : (<th>В заказ</th>) }
                </tr>
            </thead>
        );
    }

    countOrder = () => {
        let sum = 0;
        let amount = 0;

        for (let key in this.state.PRODUCTS) {
            amount++;
            sum += this.state.PRODUCTS[key].sup_amount * this.state.PRODUCTS[key].supplier_price;
        }

        return {
            amount: amount,
            sum: sum
        }
    }

    renderDeliveryTimeOptions = () => {
        let start = 4;
        let end = 22;

        if (typeof this.state.USER.delivery_times !== "undefined" && typeof this.state.USER.delivery_times2 !== "undefined") {
            let start_parts = this.state.USER.delivery_times.split(':');
            start = parseInt(start_parts[0])
            let end_parts = this.state.USER.delivery_times2.split(':');
            end = parseInt(end_parts[0])
        }

        let options = []
        for (let i = 4; i < 22; i++) {
            let local_start = i;
            let local_end = i + 1;

            if (local_start < 10) {
                local_start = '0' + local_start
            }
            if (local_end < 10) {
                local_end = '0' + local_end
            }

            let string = local_start + ':00-' + local_end + ':00';
            options.push(<option key={ i } value={ string }>{ string }</option>)
        }

        return options;
    }

    changeDeliveryDate = (date) => {
        this.setState({ DELIVERY_DATE: date })
    }

    changeOrderDate = (date) => {
        this.setState({ ORDER_DATE: date })
    }

    renderTotalsBlock = () => {
        let totals = this.countOrder();

        return (
            <div className="ordering_confirm_total">
                <div>
                    <span>Заказ:</span>
                    <span>{ totals.amount } { this.num_title(totals.amount, ['позиция', 'позиции', 'позиций']) }</span>
                </div>
                <div>
                    <span>Сумма:</span>
                    <span>{ totals.sum.toFixed(2) } руб</span>
                </div>
                <div>
                    <span>Дата доставки:</span>
                    <span>
                        <input
                            type="date"
                            name="delivery_date"
                            onChange={ (input) => this.changeDeliveryDate(input.target.value) }
                            value={ this.state.DELIVERY_DATE }
                        />
                    </span>
                </div>
                <div>
                    <span>Время доставки:</span>
                    <span>
                        <select
                            name="delivery_time"
                            onChange={ (select) => this.changeDeliveryTime(select.target.value) }
                            value={ this.state.DELIVERY_TIME }
                        >
                            { this.renderDeliveryTimeOptions() }
                        </select>
                    </span>
                </div>
                { Object.keys(this.props.TO_ORDER_PRODUCTS).length ?
                    <a className="submit_order_to_suppliers" onClick={ () => totals.amount > 0 && totals.sum > 0 ? this.saveOrderData() : alert('Проверьте цены и количества в заказе') }>
                        { this.state.SAVING ? 'Формируем заказ' : 'Создать' }
                    </a>
                    : null }
            </div>
        )
    }

    num_title = (n, titles) => {
        return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
    }

    render() {
        if (!this.state.USER || this.state.USER.selforder == 0) {
            return <Redirect to="/" />
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Формирование заказа</title>
                </Helmet>
                <div className="filter_head">
                    <h1>Формирование заказа</h1>
                </div>
                <div className="order_data_block">
                    <div className="table_holder">
                        { this.renderProducts() }
                    </div>
                    { this.renderTotalsBlock() }
                </div>
                { this.state.INFO_MODAL ?
                    <InfoModal data={ this.state.INFO_MODAL } close={ this.hideModalInfo } />
                    : null }
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(CreateRoute))
